import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["playlistIds"],
  _excluded2 = ["data"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import { useQuery } from 'react-query';
import api from 'utils/api';
import { formatPlaylistAudienceAndTeams } from 'utils/playlist/formatPlaylistAudienceAndTeams';
import { formatPlaylistAutoShare } from 'utils/playlist/formatPlaylistAutoShare';
import { hasPrivilege, PLAYLIST_WRITE } from 'utils/privileges';
import { playlistQueryKeys } from 'actions/playlists';
function formatAccessData(obj) {
  formatPlaylistAudienceAndTeams(obj);
  delete obj.contentTeams;
  delete obj.assetDomains;
  obj.parentPlaylists || (obj.parentPlaylists = []);
  obj.parentPlaylists = obj.parentPlaylists.map(function (ac) {
    return {
      id: ac.playlist.id,
      name: ac.playlist.name,
      optional: Boolean(ac.optional)
    };
  });
  obj.assetDomains$shared || (obj.assetDomains$shared = []);
  obj.domains = obj.assetDomains$shared;
  obj.domains = obj.domains.map(function (domain) {
    return _objectSpread({
      playlist_id: obj.id
    }, domain);
  });
  delete obj.assetDomains$shared;
  formatPlaylistAutoShare(obj);
  obj.isDeleted = Boolean(obj.isDeleted);
  obj.allow_member_contributions = Boolean(obj.allow_member_contributions);
  return obj;
}
function useFetchPlaylistsAccessData(_ref) {
  var playlistIds = _ref.playlistIds,
    queryOptions = _objectWithoutProperties(_ref, _excluded);
  function fetchPlaylistsAccessData() {
    return _fetchPlaylistsAccessData.apply(this, arguments);
  }
  function _fetchPlaylistsAccessData() {
    _fetchPlaylistsAccessData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var resp;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return api('get', '/api/query/collectionAsset', {
              fields: ['id', 'name', 'domain_id', 'isDeleted', 'allow_member_contributions', {
                assetDomains$shared: [{
                  assetDomainId: 'id',
                  id: 'childDomains.id',
                  name: 'childDomains.name',
                  domain: 'childDomains.domain',
                  subdomain: 'childDomains.subdomain'
                }]
              }, {
                ownerTeamId: 'team.id'
              }, {
                parentPlaylists: ['optional', {
                  playlist: {
                    name: 'name',
                    id: 'id'
                  }
                }]
              }, {
                contentTeams: ['id', 'isCalculated', {
                  team: ['name', 'id', 'isSmartTeam', 'is_deleted', {
                    teamType: ['id', 'name', 'rank', 'colour', 'role']
                  }]
                }]
              }, {
                assetDomains: ['audience', 'audienceCalculated']
              }, {
                teamSharing: ['team_id', 'is_deleted', {
                  teams: ['name', 'id', 'isSmartTeam', {
                    teamType: ['id', 'name', 'rank', 'colour']
                  }]
                }]
              }],
              join: {
                parentPlaylists: {
                  playlist: {
                    _required: true
                  }
                },
                contentTeams: {
                  isCalculated: [0, 1]
                }
              },
              filter: {
                id: playlistIds
              },
              limit: playlistIds.length,
              notfound: undefined
            });
          case 2:
            resp = _context.sent;
            return _context.abrupt("return", resp.items.map(formatAccessData));
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _fetchPlaylistsAccessData.apply(this, arguments);
  }
  var _useQuery = useQuery(playlistQueryKeys.playlistAccessDataSelection(playlistIds), fetchPlaylistsAccessData, _objectSpread({
      enabled: hasPrivilege(PLAYLIST_WRITE)
    }, queryOptions)),
    _useQuery$data = _useQuery.data,
    data = _useQuery$data === void 0 ? [] : _useQuery$data,
    result = _objectWithoutProperties(_useQuery, _excluded2);
  return _objectSpread({
    items: data
  }, result);
}
export default useFetchPlaylistsAccessData;